import React from "react";

const Footer = ({ runnungTotal }) => {
  return (
    <div>
      <h2>Runnung Total</h2>
      <p>{runnungTotal}</p>
    </div>
  );
};

export default Footer;
